import { ApiCall } from './ApiClient';

export const get = <TResponse>(def: Omit<ApiCall<never, TResponse>, 'method'>): ApiCall<never, TResponse> =>
    Object.assign(def, { method: 'get' });

export const post = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'post' });

export const put = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'put' });

export const dateTransformer = ({ ignore }: { ignore?: string[] } = {}) => {
    const ignoreSet = new Set(ignore || []);
    const self = (dto: any) => {
        if (!dto) return;
        if (Array.isArray(dto)) {
            dto.forEach(self);
        }
        else if (typeof (dto) === 'object') {
            // if (dto.createdAt) dto.createdAt = new Date(dto.createdAt);
            // if (dto.joinedAt) dto.joinedAt = new Date(dto.joinedAt);
            // if (dto.updatedAt) dto.updatedAt = new Date(dto.updatedAt);
            // if (dto.lastSeenAt) dto.lastSeenAt = new Date(dto.lastSeenAt);
            // if (dto.expiresAt) dto.expiresAt = new Date(dto.expiresAt);
            for (const key of Object.keys(dto)) {
                if (ignoreSet.has(key)) continue;
                if ((key.endsWith('At') || key.endsWith('Date')) && `${dto[key]}`?.match(/^.*T.*Z$/)) {
                    dto[key] = new Date(dto[key]);
                }
                self(dto[key]);
            }
        }
    };
    return self;
};
